import type { OwnerProfileResource } from "../../owner-profile";
import type { PriceListResource } from "../../price-list";

export enum MarketplaceTypeEnum {
  Shop = "shop",
  Erp = "erp",
  Marketplace = "marketplace",
}

export enum MarketplaceSubTypeEnum {
  Amazon = "amazon",
  Ebay = "ebay",
  Otto = "otto",
  Kaufland = "kaufland",
  Metro = "metro",
  Voelkner = "voelkner",
  Mediamarkt = "mediamarkt",
  Conrad = "conrad",
  Obs = "obs",
  B2bGate = "b2bgate",

  Oxid6 = "oxid_6",
  Oxid7 = "oxid_7",
  Shopware = "shopware",
  Shopify = "shopify",

  Erp = "erp",
}

export interface MarketplaceResource {
  id: string;
  title: string;
  is_active: boolean;
  marketplace_type: string;
  product_search_url: string | null;
  owner_profile_id: string;
  price_list_id: string | null;
  minimum_stock: string;
  reduce_stock: string;
  maximum_stock: string;
  external_stock: string;
  is_price_not_update: boolean;
  is_only_price_stock_update: boolean;
  is_excluded?: boolean;
  calculation_types: { title: string; value: string }[];
  delivery_method_id: string | null;
  payment_method_id: string | null;
  ownerProfile?: OwnerProfileResource;
  priceList?: PriceListResource;
}

export interface MarketplaceDataResource {
  id: string;
  marketplaceable_data_type: string;
  marketplaceable_data_id: string;
  marketplace_id: string;
  title: string;
  short_description: string;
  description: string;
  marketplace: MarketplaceResource;
}

export type UpdateMarketplaceRequestBody = {
  is_active?: boolean;
  title?: string;
  marketplace_type?: MarketplaceTypeEnum;
  owner_profile_id?: number;
  price_list_id?: number | null;
  minimum_stock?: number;
  reduce_stock?: number;
  maximum_stock?: number;
  external_stock?: number;
  is_price_not_update?: boolean;
  is_only_price_stock_update?: boolean;
};

export type CreateMarketplaceRequestBody = {
  is_active: boolean;
  title: string;
  marketplace_type: MarketplaceTypeEnum;
  owner_profile_id: number;
  price_list_id?: number | null;
  minimum_stock?: number;
  reduce_stock?: number;
  maximum_stock?: number;
  external_stock?: number;
  is_price_not_update?: boolean;
  is_only_price_stock_update?: boolean;
};
